export default __webpack_public_path__ + "static/media/app-store-button.9b0109b7.svg";